import { render, staticRenderFns } from "./HostingDns.vue?vue&type=template&id=0edea8f4&"
import script from "./HostingDns.vue?vue&type=script&lang=js&"
export * from "./HostingDns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports